import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Fade } from "react-awesome-reveal";
import "swiper/css";

import SectionTitle from "../home/SectionTitle";
import SliderLine from "../home/SliderLine";

import bannerCloud from "../../img/home/banner-cloud.webp";

const CARDS = [
  { titleKey: "markets.built.card1.title", text1Key: "markets.built.card1.text1", text2Key: "markets.built.card1.text2" },
  { titleKey: "markets.built.card2.title", text1Key: "markets.built.card2.text1", text2Key: "markets.built.card2.text2" },
  { titleKey: "markets.built.card3.title", text1Key: "markets.built.card3.text1", text2Key: "markets.built.card3.text2" },
  { titleKey: "markets.built.card4.title", text1Key: "markets.built.card4.text1", text2Key: "markets.built.card4.text2" },
  { titleKey: "markets.built.card5.title", text1Key: "markets.built.card5.text1", text2Key: "markets.built.card5.text2" },
  { titleKey: "markets.built.card6.title", text1Key: "markets.built.card6.text1", text2Key: "markets.built.card6.text2" },
];

function FeatureCard({ card, t }) {
  return (
    <Fade triggerOnce direction="up" duration={600} className="h-full">
      <div className="relative h-full overflow-hidden rounded-[20px] p-[25px] lg:p-[32px] bg-[rgba(22,36,56,0.8)] border border-[rgba(255,255,255,0.08)] backdrop-blur-[4px] flex flex-col gap-[12px] hover:-translate-y-[4px] transition-transform duration-300">
        <div className="absolute left-0 top-0 bottom-0 w-[4px] bg-[#4da6ff]" />
        <div className="check-icon-blue">
          <Check className="w-[14px] h-[14px] text-[#4da6ff]" strokeWidth={2.5} />
        </div>
        <p className="font-['Inter'] font-bold text-[16px] lg:text-[20px] leading-[1.2] text-white">
          {t(card.titleKey)}
        </p>
        <p className="font-16-14-dark">{t(card.text1Key)}</p>
        <p className="font-16-14-dark">{t(card.text2Key)}</p>
      </div>
    </Fade>
  );
}

function Features() {
  const { t } = useTranslation();
  const swiperRef = useRef(null);
  const [current, setCurrent] = useState(0);

  return (
    <section
      className="mt relative overflow-hidden"
      style={{ backgroundImage: "linear-gradient(101deg, #232e3e 7.8%, #31435c 98%)" }}
    >
      {/* Облака */}
      <img
        src={bannerCloud}
        alt=""
        aria-hidden
        className="absolute left-[57%] top-[-164px] w-[74%] opacity-20 -scale-x-100 pointer-events-none select-none"
      />
      <img
        src={bannerCloud}
        alt=""
        aria-hidden
        className="absolute left-[-31%] top-[-24px] w-[74%] opacity-20 -scale-x-100 pointer-events-none select-none"
      />

      <div className="relative glcontainer py-[35px] lg:py-[60px]">
        <SectionTitle
          title1={t("markets.built.title1")}
          title2={t("markets.built.title2")}
          text={t("markets.built.subtitle")}
          dark
          className="mx-auto max-w-[533px]"
        />

        {/* Desktop: сетка 2x3 с разделителем */}
        <div className="hidden lg:flex flex-col gap-[24px] mt-[40px]">
          <div className="grid grid-cols-3 gap-[24px]">
            {CARDS.slice(0, 3).map((card) => (
              <FeatureCard key={card.titleKey} card={card} t={t} />
            ))}
          </div>
          <div className="h-px w-full bg-[rgba(255,255,255,0.08)]" />
          <div className="grid grid-cols-3 gap-[24px]">
            {CARDS.slice(3).map((card) => (
              <FeatureCard key={card.titleKey} card={card} t={t} />
            ))}
          </div>
        </div>

        {/* Mobile / tablet: слайдер */}
        <div className="lg:hidden mt-[25px]">
          <Swiper
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            onSlideChange={(swiper) => setCurrent(swiper.realIndex)}
            spaceBetween={16}
            slidesPerView={1}
            grabCursor
            breakpoints={{ 640: { slidesPerView: 2, spaceBetween: 20 } }}
          >
            {CARDS.map((card) => (
              <SwiperSlide key={card.titleKey} className="!h-auto">
                <FeatureCard card={card} t={t} />
              </SwiperSlide>
            ))}
          </Swiper>
          <SliderLine
            dark
            current={current}
            total={CARDS.length}
            onPrev={() => swiperRef.current?.slidePrev()}
            onNext={() => swiperRef.current?.slideNext()}
          />
        </div>
      </div>
    </section>
  );
}

export default Features;
